module.exports = __webpack_public_path__ + "static/media/27-1.0821c701.mp3";